defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClub/Header',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Mithril/Scripts/Helpers/Scroll',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlaysCardsSlider'
  ],
  function (m, Scroll, Utils, CtaButton, PlaysCardsSlider) {

    // View:
    var Header = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
      },
      view: function (controller) {
        // View:
        return m('.play-together-club-header', {
          config: controller.initHeader
        }, m('.play-together-club-header__inner-wrapper', [
          controller.clubModelFields().myOffersAndActivePlays().length > 0 ?
            m('.play-together-club-header__top', [
              m('div', m.trust(controller.viewClubDictionary('ClubHeaderActivePlaysCount', {
                clubActivePlaysCount: controller.clubModelFields().activePlaysCount(),
                yourActivePlaysInTheClubCount: controller.clubModelFields().myActivePlaysCount()
              })))
            ])
            : null,
          controller.clubModelFields().myOffersAndActivePlays().length > 0 ?
            m.component(PlaysCardsSlider, { controller: controller }) :
            m('.play-together-cards-list__empty-wrapper', [
              m('.play-together-cards-list__empty-wrapper-image.play-together-cards-list__empty-wrapper-image--left', {
                style: 'background-image: url("/Components/DanskeSpil/Domain/PlayTogether/Graphics/club-view-no-plays-left.png")'
              }),
              m('.play-together-cards-list__empty-wrapper-image.play-together-cards-list__empty-wrapper-image--right', {
                style: 'background-image: url("/Components/DanskeSpil/Domain/PlayTogether/Graphics/club-view-no-plays-right.png")'
              }),
              m('.play-together-cards-list__empty-wrapper-content', [
                m('.play-together-cards-list__empty-wrapper-title', controller.viewClubDictionary('EmptyPlaysList/Title')),
                m('.play-together-cards-list__empty-wrapper-description', controller.viewClubDictionary('EmptyPlaysList/Description')),
                controller.showCreatePlayButton() ? CtaButton({
                  text: controller.viewClubDictionary('CreateNewGameButton'),
                  href: controller.navigationPaths.createPlayChooseGamePage + '?klubId=' + controller.clubModelFields().clubId(),
                  options: ['small']
                }) : null
              ])
            ])
        ]));
      }
    };

    // Public functions:
    return Header;

  });
